/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 육군홍보관 지원 WEB RestAPI 서비스
 * 버전 : 1.0
 * 파일명 : App.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * 수정 : 2025-07-01, 강동형 : 저작권 추가
 * ================================================================ 
 * 수정 : 2025-07-10, 강동형 : 글로벌 CSS 추가, line-height :1.32 적용
 * 수정 : 2025-12-05, 강동형 : React 19.2.1로 버전 업
 * */

import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, CssBaseline, GlobalStyles } from '@mui/material';
import theme from './theme/theme';
import AppContent from './AppContent'; // 분리된 내용
import { Navigate, useLocation } from 'react-router-dom';

const PreventTrailingSlash = ({ children }: { children: React.ReactNode }) => {
  const { pathname } = useLocation();

  // 루트 '/'는 허용하지만, 나머지 경로에만 적용
  if (pathname !== '/' && pathname.endsWith('/')) {
    return <Navigate to={pathname.replace(/\/+$/, '')} replace />;
  }

  return <>{children}</>;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles styles={{ body :{lineHeight:1.32}}}/>
      <BrowserRouter> {/* ✅ 최상위 BrowserRouter 하나만 */}
        <PreventTrailingSlash>
          <AppContent />
        </PreventTrailingSlash>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
